import { render } from "./error-message.vue?vue&type=template&id=163d26fe"
import script from "./error-message.vue?vue&type=script&lang=ts"
export * from "./error-message.vue?vue&type=script&lang=ts"
script.render = render

export default script